import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoute = () => {
    const login = JSON.parse(localStorage.getItem('login')) ? JSON.parse(localStorage.getItem('login')) : false;
    const role = (localStorage.getItem('userRole') || '').toLowerCase();
    const { pathname } = useLocation();

    if (login === false) {
        return <Navigate to={`/login`} />;
    }

    const isCustomerArea = pathname.startsWith('/customer');

    // Customers may only access the customer portal; staff may not enter it.
    if (role === 'customer' && !isCustomerArea) {
        return <Navigate to={`/customer/dashboard`} />;
    }
    if (role !== 'customer' && isCustomerArea) {
        return <Navigate to={`/dashboard`} />;
    }

    return <Outlet />;
};
export default PrivateRoute;
